export const NoWrap: React.FC = ({ children }) => (
    <span style={{whiteSpace: 'nowrap'}}>{children}</span>
);
